// extracted by mini-css-extract-plugin
export default {"inbodyKeyTable":"tRxswkh1GOdCVqWODtba"};